import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import { appLogoType, loginCred } from '../api/types';

import {
  editSingleUserById,
  GetCurrentUser,
  SetCurrentUser,
  User,
  GetSingleUserById,
  UserFormValues,
  InstantPageUser,
} from '../models/user';

import { ClearAllStore } from './clearAllStore';
import { store } from './store';

export default class UserStore {
  static getUser() {
    throw new Error('Method not implemented.');
  }
  userList: User[] = [];
  user: GetCurrentUser | null = null;
  tenantNames: string[] = [];
  loadAllUsers: User[] = [];
  resetpasswords: UserFormValues | null = null;
  defaultpasswords: GetSingleUserById | null = null;
  EditUser: GetSingleUserById | null = null;
  DeleteUser: User | null = null;
  loadingInitial = false;
  loadingInitialEditUser = false;
  formMainpageData: string = '';
  registeredCustomerName: string[] = [];
  instantpageUsernameAndEmailValidate: string = '';
  instantpageRoleIdValidation: string = '';
  instantPageRoleIdValidationData: any;
  instantpageFormInformation: any;
  instantpageRedirectPage: boolean = false;
  MarkloginDepartmentData: any[] = [];
  markloginUserNameData: { key: string; value: string; text: string }[] = [];
  markloginUserNameDropDownData: string = '';
  markloginDropDownTwo: boolean = false;
  appLogo: appLogoType = {
    id: '',
    customerName: '',
    logoUrl: '',
  };

  constructor() {
    makeAutoObservable(this);
  }

  get isLoggedIn() {
    return !!this.user;
  }
  get isInstantPageLogin() {
    return !!this.instantpageUsernameAndEmailValidate;
  }

  listOfTenants = async (email: string) => {
    try {
      const params = { email };
      const listOfTenants = await agent.Account.listOfTenants(params);
      runInAction(() => {
        if (listOfTenants.data?.length) {
          this.tenantNames = listOfTenants.data;
        } else {
          toast.info('Invalid username');
        }
      });
      return this.tenantNames;
    } catch {
      var validRegex =
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      if (email.match(validRegex)) {
        toast.error('Unable to fetch Tenant');
      }
    }
  };

  login = async (
    email: string,
    password: string,
    customerName: string,
    reDirect: any,
  ) => {
    try {
      const payload: loginCred = {
        email: email,
        password: password,
      };
      const user = await agent.Account.loginCustomerBased(
        payload,
        customerName,
      );
      if (typeof user === 'string') {
        toast.error(user);
        return;
      }
      store.commonStore.setToken(user.token);
      runInAction(() => {
        if (user.isDeleted === true) {
          store.commonStore.setToken(null);
        } else {
          this.user = user;

          // store.activityStore.loadActivities();
          // store.emailStore.loadEmails();
          // store.dashboardStore.updateCountOrderMenu(user.id);
        }
      });
      if (window.innerWidth < 768) {
        reDirect();
      }
      user.isDeleted === true
        ? toast.error('Your Account is already deleted')
        : toast.success('Login Successful, Welcome...');
      store.modalStore.closeModal();

      // window.location.reload();
    } catch (error) {
      if (customerName) {
        toast.error('Invalid Credentials');
      } else {
        toast.error('Please select the tenant to login');
      }
      throw error;
    }
  };

  resetpassword = async (creds: UserFormValues) => {
    try {
      const payload = {
        id: creds?.id,
        password: creds.password,
        newPassword: creds.newPassword || 'Pa$$w0rd',
      };
      await agent.Account.reset(payload);
      store.commonStore.setNewPassword(payload?.newPassword);
      store.commonStore.setToken(null);
      window.localStorage.removeItem('jwt');
      toast.success('Password Changed Successfully');
      store.modalStore.closeModal();
      this.logout();
    } catch (error) {
      toast.error('Please Try again');
      throw error;
    }
  };

  logout = () => {
    //clear all the store
    localStorage.clear();
    if(store.commonStore.RestorationCustomer){
      store.TrackingReportStore.FooterOperatorRemainter = ''
    } 
    ClearAllStore();
    this.userList = [];
    store.commonStore.setToken(null);
    window.localStorage.removeItem('jwt');
    window.localStorage.removeItem('barcodeApi');
    window.localStorage.removeItem('customerLanguageSelection');
    this.user = null;

    toast.success('Logout Succesfully');
    //
    // localStorage.clear();
  };
  // get  user info
  getUser = async () => {
    this.loadingInitial = true;
    try {
      const user = await agent.Account.current();
      runInAction(() => (this.user = user));
    } catch (error) {
      toast.error('Please try again !');
    }
    this.loadingInitial = false;
  };

  resetPasswordOnFirstEverLogin = async (creds: UserFormValues) => {
    try {
      const payload = {
        id: creds.id,
        password: creds.password,
        newPassword: creds.newPassword || 'Pa$$w0rd',
      };
      await agent.Account.reset(payload);
      store.commonStore.setNewPassword(payload?.newPassword);
      store.commonStore.setToken(null);
      window.localStorage.removeItem('jwt');
      toast.success('Password Changed Successfully');
      store.modalStore.closeModal();
      this.logout();
    } catch (error) {
      toast.error('Please Try again');
      throw error;
    }
  };

  get getUsers() {
    if (this.userList.length === 0) {
      this.loadUsers();
    }
    return this.userList;
  }

  loadUsers = async () => {
    this.loadingInitial = true;
    try {
      const users = await agent.Account.list();
      this.userList = [...users];
      this.loadingInitial = false;
    } catch (error) {
      toast.error('Please try again !');
      this.loadingInitial = false;
    }
  };

  // allUsers
  loadAllUserss = async () => {
    try {
      const allusertrackdetails = await agent.Account.allUsers();
      runInAction(() => {
        this.loadAllUsers = allusertrackdetails;
      });
      return this.loadAllUsers;
    } catch (error) {
      console.log(error, 'errror');
    }
  };

  register = async (creds: GetSingleUserById, dashboardRedirect: any) => {
    try {
      const registerArr: any[] = [];
      const data = await agent.Account.registerCustomerBased(creds);
      if (registerArr) {
        registerArr.push(data);
      }

      if (!this.isLoggedIn) {
        dashboardRedirect();
      } else {
        this.loadUsers();
      }
      store.modalStore.closeModal();
      if ((registerArr[0]?.errors).length === 0) {
        toast.success('User registered Succesfully');
      }
    } catch (error) {
      console.log('err', error);
    }
  };
  setImage = (image: string) => {
    if (this.user) this.user.image = image;
  };
  // update current user
  updateCurrentUser = async (currentUser: SetCurrentUser) => {
    try {
      await agent.Account.updatecurrentuser(currentUser);

      runInAction(() => {
        this.getUser();
      });
      toast.success('User Updated succesfully');
    } catch (error) {
      console.log('err', error);
    }
  };

  // update  any user
  updateUser = async (userId: string, userinfo: editSingleUserById) => {
    try {
      await agent.Account.update(userId, userinfo);

      runInAction(() => {
        this.loadUsers();
      });
      toast.success('User Updated succesfully');
    } catch (error) {
      console.log('err', error);
    }
  };
  // details of any user
  getEditUser = async (id: any) => {
    this.loadingInitialEditUser = true;
    try {
      const userDetail = await agent.Account.details(id);
      runInAction(() => {
        this.EditUser = userDetail;
      });
      this.EditUser !== null
        ? (this.loadingInitialEditUser = false)
        : (this.loadingInitialEditUser = true);
    } catch (err) {
      console.log(err);
    }
  };
  deleteUser = async (userId: string) => {
    try {
      const response1 = await agent.Account.deletePhoto(userId);
      runInAction(async () => {
        if (response1.status === 200) {
          setTimeout(async () => {
            const response2 = await agent.Account.deleteUser(userId);
            if (response2.status === 200) {
              toast.success('User deleted succesfully.');
              this.loadUsers();
            }
          }, 100);
        }
      });
    } catch (error) {
      toast.error('Please try again !');
    }
  };

  loginFormRegister = async (data: InstantPageUser, reDirect: any) => {
    try {
      const payload: loginCred = {
        email: data.email,
        password: data.password,
      };
      this.instantpageFormInformation = data;
      new Promise(async (resolve) => {
        const value = await agent.Account.InstantpageRegister(data);
        if (typeof value?.data === 'string') {
          if (value?.data?.includes('already exist')) {
            this.instantpageUsernameAndEmailValidate = value?.data;
            toast.error(`${value.data}`);
          } else {
            this.instantpageUsernameAndEmailValidate = '';
            toast.success('Login Created Successfully');
          }
        } else if (value?.data?.errors[0]?.description !== undefined) {
          this.instantpageUsernameAndEmailValidate =
            value?.data?.errors[0]?.description;
          toast.error(`${value?.data?.errors[0]?.description}`);
        } else {
          toast.success('Login Created Successfully');
        }
        resolve('');
      }).then(async () => {
        const user2 = await agent.Account.loginCustomerBased(
          payload,
          data.companyName,
        );
        store.commonStore.setToken(user2.token);
        this.instantPageTemlateApi(
          this.instantPageRoleIdValidationData,
          reDirect,
        );
      });
    } catch (error) {
      toast.error('Please try again !');
    }
  };
  instantpagecustomerRegister = async () => {
    try {
      const CustomerName = await agent.Account.customersRegister();
      const roleId: any = await agent.Account.CustomerBasedRoleId();
      this.instantpageRoleIdValidation = roleId.data.id;
      this.instantPageRoleIdValidationData = roleId.data;
      this.registeredCustomerName.push(...CustomerName.data);
    } catch (error) {
      toast.error('Please try again !');
    }
  };
  instantPageTemlateApi = async (data: any, reDirect: any) => {
    try {
      new Promise(async (resolve) => {
        await agent.Account.InstantpageTemplate(data);
        resolve('');
      }).then(async () => {
        var FrontEndIds = await agent.Account.InstantpageFrontEndIds(data.id);
        await agent.Account.InstantpageAddFrontEndIds(
          data.id,
          FrontEndIds.data,
        );
        reDirect();
      });
    } catch (error) {
      toast.error('Please try again !');
    }
  };

  resetdefaultpassword = async (id: any) => {
    try {
      await agent.Account.defaultPassword(id);
      await agent.Account.unBlock(id);
      toast.success('Password Updated');
      store.modalStore.closeModal();
    } catch (error) {
      toast.error('Please Try again');
      throw error;
    }
  };
  InstantpageRedirectoption = () => {
    this.instantpageRedirectPage = true;
  };
  loginOutLoginpage = () => {
    this.instantpageUsernameAndEmailValidate = '';
  };

  DepartmentNameAddMarkLogin = async () => {
    try {
      const response = await agent.Departments.MarkloginDepartment(
        this.user?.customerName,
      );
      runInAction(() => {
        let data: any[] = [];
        response.data.forEach((item: any) => {
          data.push({
            key: item,
            value: item,
            text: item,
          });
        });
        this.MarkloginDepartmentData = data.filter(
          (el, i, a) => i === a.indexOf(el),
        );
      });
    } catch (error) {
      toast.error('Something went to wrong....');
    }
  };

  UserNameAddMarkLogin = async (item: string) => {
    try {
      this.markloginUserNameData.length = 0;
      let response: any = await agent.Departments.MarkloginUserDetails(item);
      runInAction(() => {
        response.data.forEach((item: any) => {
          this.markloginUserNameData.push({
            key: item.username,
            value: item.username,
            text: item.username,
          });
        });
      });
    } catch (error) {
      toast.error('Something went to wrong....');
    }
  };

  getLogo = async () => {
    try {
      const response: any = await agent.Profiles.getAppLogo();
      runInAction(() => {
        this.appLogo = {
          ...response.data,
        };
      });
    } catch (error) {
      console.log('Failed to get Logo', error);
    }
  };

  setLogo = async (params: { Url: string }) => {
    try {
      const response: any = await agent.Profiles.setAppLogo(params);
      runInAction(() => {
        this.appLogo = {
          ...response.data,
        };
      });
    } catch (error) {
      console.log('Failed to set Logo', error);
    }
  };

  emailDetails = {
    name: '',
    company:
      this.user?.customerName !== null
        ? this.user?.customerName
        : 'Prasad Corp',
    create: `This notification is  to confirm you that you have successfully created record for `,
    Date: `${new Date().toLocaleDateString()}`,
    Notification: `This notification is to inform you that `,
    deleted:
      'This notification is to confirm you that you have successfully deleted record for',
    created: `This notification is to confirm you that you have successfully created record for`,
    edited: `This notification is to confirm you that you have successfully edited record for`,
    modified: `This notification is to confirm you that you have successfully modified data for`,
    cloned: `This notification is to confirm you that you have successfully cloned record for`,
    added: `This notification is to confirm you that you have successfully added User`,
    register: `This notification is to inform you that `,
  };
  email = {
    id: '',
    email: '',
    email_copy: '',
    subject: 'Created',
    body: '',
    filename: '',
    /* eslint-disable */
    model: `{ \"name\":\"${this.emailDetails.name}\", \"company\":\"${this.emailDetails.company}\" }`,
    status: true,
  };
}
